module.exports = __webpack_public_path__ + "img/brand-stickermule.b893261c.svg";